export default "__VITE_ASSET__CJ3iOJY1__"